<template>
    <div>
        <p>
            {{ ccustomerAbbreviationName || cCustomerName }}
        </p>
    <!--
      <p v-if="cContact">
      Liên hệ kinh doanh: {{ cContact.name }} - {{ cContact.phone }}
      </p>
      <p v-if="cContactLogistic">
      Liên hệ Logistic: {{ cContactLogistic.name }} - {{ cContactLogistic.phone }}
      </p>
    -->
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const ccustomerAbbreviationName = computed(() => params?.value?.data?.customerAbbreviationName)
const cCustomerName = computed(() => params?.value?.data?.customerName)

const cContact = computed(() => {
  const { contactName, contactEmail, contactPhone } = params?.value?.data || {}
  if (!contactName || !contactPhone) {
    return ''
  }

  return {
    name: contactName,
    phone: contactPhone
  }
})

const cContactLogistic = computed(() => {
  const { logisticContactName, logisticContactPhone, logisticContactEmail } = params?.value?.data || {}
  if (!logisticContactName || !logisticContactPhone) {
    return ''
  }

  return {
    name: logisticContactName,
    phone: logisticContactPhone
  }
})
</script>
